import moment from 'moment';

export function isValidDate(date: Date): boolean {
  const formattedDate = date ? moment(date) : null;

  return formattedDate && !formattedDate.isSameOrBefore(new Date('01/01/0001'));
};

export function getDate(date: Date, time: Date) {
  return moment({
    year: date?.getFullYear(),
    month: date?.getMonth(),
    date: date?.getDate(),
    hour: time?.getHours(),
    minutes: time?.getMinutes()
  }).utc().toDate();
}